import React from 'react';
import { Checkbox } from '@mui/material';
import { FileListStateShape } from '../hooks/useFileListState';

export const FileMasterCheckbox = ({ fileListState }) => {
  const { isAllChecked, isSomeChecked, toggleAll } = fileListState;

  return (
    <Checkbox
      checked={isAllChecked}
      indeterminate={isSomeChecked && !isAllChecked}
      onChange={toggleAll}
    />
  );
};

FileMasterCheckbox.propTypes = {
  fileListState: FileListStateShape.isRequired,
};
